import FormatUtil from '../utils/format'

let defaultAlertOptions = {
  confirmButtonText: 'OK',
  showCancelButton: false,
  dangerouslyUseHTMLString: false
}

let defaultConfirmOptions = {
  confirmButtonText: 'OK',
  cancelButtonText: 'キャンセル',
  showCancelButton: true,
  dangerouslyUseHTMLString: false
}

export default class MessageBox {

  static alert (context, message, options = null) {
    options = Object.assign({}, defaultAlertOptions, options)
    return context.$alert(message, options)
  }

  static confirm (context, message, options = null) {
    options = Object.assign({}, defaultConfirmOptions, options)
    return context.$confirm(message, options)
  }

  static protectedConfirm (context, message, title, options = null) {
    options = Object.assign({}, defaultConfirmOptions, options)
    return context.$prompt(message, title, options)
  }

  static passwordConfirm (context, message, password) {
    return this.protectedConfirm(context, message, 'パスワード入力', {
      dangerouslyUseHTMLString: true,
      inputType: 'password',
      inputPattern: new RegExp('^' + FormatUtil.escapeRegex(password) + '$'),
      errorMessage: null
    })
  }

  static deleteModelConfirm (context, message, key, errorMessage) {
    return this.protectedConfirm(context, message, 'モデル削除', {
      dangerouslyUseHTMLString: true,
      confirmButtonText: '削除',
      confirmButtonClass: 'delete-confirm-button',
      inputPattern: new RegExp('^' + FormatUtil.escapeRegex(key) + '$'),
      errorMessage: errorMessage,
      inputErrorMessage: errorMessage
    })
  }

  static modelNameChangeConfirm (context, message, modelName) {
    return this.protectedConfirm(context, message, 'モデル名変更', {
      dangerouslyUseHTMLString: true,
      confirmButtonText: '変更',
      inputValue: modelName,
      inputPattern: null
    })
  }
}



// WEBPACK FOOTER //
// ./src/utils/message-box.js